// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"cd7e5957","977":"995730a7"}[chunkId] + ".chunk.js";
};